import SessionsList from './sessionsList';
import RequestsList from './requestsList.vue';
import JudgementsList from './judgementsList.vue';
import ListView from './listView.vue';
import AttachmentForm from './attachment-form.vue';

import local from '@/local/ar';
export default [
  {
    name: 'SessionsList - قائمة الجلسات',
    value: 'sessionsList',
    component: SessionsList,
    fieldsTechnicalNames: [],
  },
  {
    name: 'RequestsList - قائمة الطلبات',
    value: 'requestsList',
    component: RequestsList,
    fieldsTechnicalNames: [],
  },
  {
    name: 'JudgementsList - قائمة الاحكام',
    value: 'judgementsList',
    component: JudgementsList,
    fieldsTechnicalNames: [],
  },
  {
    name: 'ListView - عرض قائمة ',
    value: 'listView',
    component: ListView,
    fieldsTechnicalNames: [],
  },
  {
    name: 'إضافة مرفق',
    value: 'AttachmentForm',
    component: AttachmentForm,
    fieldsTechnicalNames: [],
  },
];
